import { render, staticRenderFns } from "./GmbLabelsCreateGroupDialog.vue?vue&type=template&id=7cb36238&scoped=true&"
import script from "./GmbLabelsCreateGroupDialog.vue?vue&type=script&lang=js&"
export * from "./GmbLabelsCreateGroupDialog.vue?vue&type=script&lang=js&"
import style0 from "./GmbLabelsCreateGroupDialog.vue?vue&type=style&index=0&id=7cb36238&lang=scss&scoped=true&"
import style1 from "./GmbLabelsCreateGroupDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb36238",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VIcon,VList,VListItem,VListItemContent,VTextField,VVirtualScroll})
